<ion-app class="lang-{{currLang}}">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
 